import { useQuery } from 'react-query'
import { getCards } from 'services/loans'

export default function useGetCards(id: number | undefined) {
    const { data, isLoading } = useQuery(['get-my-cards', id], getCards)
    return { data, isLoading }
}
